import { ButtonGroup, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import moment from "moment";

const useStyles = makeStyles({
  imageContainer: {
    display: "flex",
    flexDirection: "column !important",
    alignItems: "center",
    justifyContent: "center",
    padding: "1rem 1rem 1rem 0",
    gap: "1rem",
  },
  icons: {
    cursor: "pointer",
    color: "black",
  },
  disabledIcon: {
    cursor: "not-allowed",
    color: "#787878",
  },
  buttonGroup: {
    width: "100%",
    display: "flex !important",
    justifyContent: "space-between",
  },
  timestamp: {
    alignSelf: "center",
    fontSize: "1rem",
    color: "black",
  },
  image: {
    height: "30vh",
    width: "100%",
    objectFit: "contain",
  },
});

const ImageCarousel = ({ images }) => {
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => {
      if (prevIndex === images.length - 1) {
        // If currently at the last image, stay at the last image
        return prevIndex;
      } else {
        // Otherwise, go to the next image
        return prevIndex + 1;
      }
    });
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => {
      if (prevIndex === 0) {
        // If currently at the first image, stay at the first image
        return prevIndex;
      } else {
        // Otherwise, go to the previous image
        return prevIndex - 1;
      }
    });
  };

  const getCurrentTimestamp = () => {
    return moment(images[currentIndex]?.createdAt).format("hh:mm:ss A MMM DD, YYYY");
  };

  return (
    <Grid container className={classes.imageContainer}>
      <Grid item xs={12} sx={{ width: "100%", backgroundColor: "black" }}>
        {Object.keys(images).map((key, index) => (
          <div key={index} style={{ display: index === currentIndex ? "block" : "none" }}>
            <img src={images[key].url} alt={`Images ${index + 1}`} className={classes.image} />
          </div>
        ))}
      </Grid>
      <ButtonGroup className={classes.buttonGroup}>
        <ArrowBackIosNewIcon
          className={currentIndex === 0 ? classes.disabledIcon : classes.icons}
          onClick={goToPrevious}
        />
        <span className={classes.timestamp}>{getCurrentTimestamp()}</span>
        <ArrowForwardIosIcon
          className={currentIndex === images.length - 1 ? classes.disabledIcon : classes.icons}
          onClick={goToNext}
        />
      </ButtonGroup>
      <Typography variant="caption" sx={{ textAlign: "center", color: " #787878" }}>
        Video is not available
      </Typography>
    </Grid>
  );
};

export default ImageCarousel;
